import { gql } from "@apollo/client";
import {TypeDefinitionAttributeFields} from "../fragments/typeDefinitionAttribute";

export const InstalledBaseNodeTdas = gql`
  query InstalledBaseNodeTdas ($id: ID!) {
    installedBaseNode (id: $id) {
      id
      nodeType {
        id
        key
        name
        description
      }
      image {
        id
        file {
          id
          thumbnailLink(crop: fit, w: 200, h: 200)
        }
      }
      typeDefinitionAttributeList {
        total
        typeDefinitionAttributes {
          ...TypeDefinitionAttributeFields
        }
      }
    }
  }
  ${TypeDefinitionAttributeFields}
`;
